import React from 'react';
import {Mainentry} from '../entries'
import {WithModal} from '../';


export default class Main extends WithModal {
    render() {
        return (
            <span>
                <Mainentry {...this.props} openModal={this.openModal.bind(this)}/>
                {(() => {
                    return super.render();
                })()
                }
                <div className="col-md-12">
                    <div className="row">
                            <h3>м.Новодністровськ, мкр."Сонячний", 3А</h3>
                            <h3>тел. +380 (3741) 3-15-75</h3>
                    </div>
                </div>
            </span>
        );
    }
}







// WEBPACK FOOTER //
// ./src/components/Main/index.jsx